"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initApdexEventListener = exports.ApdexTracker = void 0;
var apdex_1 = __importDefault(require("./apdex"));
var apdexEventsName_1 = require("./apdexEventsName");
var ApdexTracker = {
    begin: function (eventName) {
        return document.dispatchEvent(new CustomEvent(apdexEventsName_1.ApdexEventType.BEGIN, { detail: { timestamp: performance.now(), eventName: eventName } }));
    },
    rendered: function (eventName, options) {
        return document.dispatchEvent(new CustomEvent(apdexEventsName_1.ApdexEventType.RENDERED, {
            detail: { timestamp: performance.now(), eventName: eventName, projectId: options === null || options === void 0 ? void 0 : options.projectId },
        }));
    },
    sendRequest: function (eventName) {
        return document.dispatchEvent(new CustomEvent(apdexEventsName_1.ApdexEventType.SEND_REQUEST, { detail: { timestamp: performance.now(), eventName: eventName } }));
    },
    responseReceived: function (eventName) {
        return document.dispatchEvent(new CustomEvent(apdexEventsName_1.ApdexEventType.RESPONSE_RECEIVED, {
            detail: { timestamp: performance.now(), eventName: eventName },
        }));
    },
};
exports.ApdexTracker = ApdexTracker;
var initApdexEventListener = function () {
    var metrics = {};
    document.addEventListener(apdexEventsName_1.ApdexEventType.BEGIN, (function (_a) {
        var detail = _a.detail;
        metrics[detail.eventName] = { begin: detail.timestamp, sendRequest: 0, responseReceived: 0, rendered: 0 };
    }));
    document.addEventListener(apdexEventsName_1.ApdexEventType.SEND_REQUEST, (function (_a) {
        var detail = _a.detail;
        metrics[detail.eventName] = __assign(__assign({}, metrics[detail.eventName]), { sendRequest: detail.timestamp });
    }));
    document.addEventListener(apdexEventsName_1.ApdexEventType.RESPONSE_RECEIVED, (function (_a) {
        var detail = _a.detail;
        metrics[detail.eventName] = __assign(__assign({}, metrics[detail.eventName]), { responseReceived: detail.timestamp });
    }));
    document.addEventListener(apdexEventsName_1.ApdexEventType.RENDERED, (function (_a) {
        var detail = _a.detail;
        metrics[detail.eventName] = __assign(__assign({}, metrics[detail.eventName]), { rendered: detail.timestamp });
        apdex_1.default.emit(detail.eventName, {
            projectId: detail.projectId,
            renderTime: metrics[detail.eventName].rendered - metrics[detail.eventName].begin,
            requestTime: metrics[detail.eventName].responseReceived - metrics[detail.eventName].sendRequest,
        });
    }));
};
exports.initApdexEventListener = initApdexEventListener;
